import { Component } from 'react';
import { connect } from 'react-redux';

import AddressDisplay from 'common/components/address/AddressDisplay';
import { listCustomerAddresses } from 'redux/customerAddresses/actions';

class ListModal extends Component {
  componentDidMount() {
    const { props } = this;
    props.listCustomerAddresses();
  }

  handleEditAddress = (e) => {
    e.preventDefault();
    const { props } = this;
    const id = e.currentTarget.getAttribute('data-id');
    props.onEditAddress(id);
  };

  handleSelectAddress = (e) => {
    e.preventDefault();
    const { props } = this;
    const id = e.currentTarget.getAttribute('data-id');
    const address = props.customerAddresses.data[id];
    props.onSelectAddress(address);
  };

  render() {
    const { settings, customerAddresses } = this.props;
    if (!settings.data || !customerAddresses.data) {
      return null;
    }
    const addressIdArray = Object.keys(customerAddresses.data);
    const displayArray = arrayOf2(addressIdArray);
    return (
      <>
        {displayArray.map((innerArray) => (
          <div key={innerArray[0]} className="c7-account-row">
            {innerArray.map((addressId) => {
              const address = customerAddresses.data[addressId];
              return (
                <div key={address.id}>
                  <AddressDisplay address={address} boldName />
                  <br />
                  {address.isDefault && (
                    <>
                      <br />
                      <em>(Default)</em>
                    </>
                  )}
                  <br />
                  <a onClick={this.handleEditAddress} data-id={address.id}>
                    Edit
                  </a>
                  &nbsp;&nbsp;|&nbsp;&nbsp;
                  <a onClick={this.handleSelectAddress} data-id={address.id}>
                    Select
                  </a>
                </div>
              );
            })}
          </div>
        ))}
      </>
    );
  }
}

const arrayOf2 = (array) => {
  const arrayOutput = [];
  let innerArray = [];
  array.forEach((element, index) => {
    innerArray.push(element);
    if ((index + 1) % 2 === 0) {
      arrayOutput.push(innerArray);
      innerArray = [];
    }
  });
  if (innerArray.length > 0) {
    arrayOutput.push(innerArray);
  }
  return arrayOutput;
};

const mapStateToProps = (state) => ({
  customerAddresses: state.customerAddress,
  settings: state.setting
});

export default connect(mapStateToProps, {
  listCustomerAddresses
})(ListModal);
